<template lang="html">
  <footer class="main-footer">
    <p>&copy; 2017 pmg marketing tours, charlotte north carolina. all rights reserved.</p>
  </footer>
</template>

<script>
  export default {
    name: 'main-footer',
    data () {
      return {

      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .main-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    font-family: $montserrat;
    font-size: 0.7rem;
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 2px;
    background-color: $dark-blue;
    color: $light-blue;
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue